import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  content: {
    padding: `${styles.spacing(10)}px ${styles.spacing(8)}px`,
    transition: styles.transitions.regular(['padding']),
    [styles.breakpoints.down('lg')]: {
      padding: `${styles.spacing(5)}px`,
    },
    [styles.breakpoints.down('md')]: {
      borderRadius: 0,
      padding: `${styles.spacing(4)}px`,
    },
  },
});
